export class Signup {
    firstname: string;
    companyname: string;
    username: string;
    password: string;
    confirmpwd: string;
    ieccode: string;
    companytype: string;
    stuffingType: string;
   


    constructor(fname: string, cmpy: string, u: string, pwd: string, cpwd: string, iec: string, ctype: string, stype: string) {
        this.firstname = fname;
        this.companyname = cmpy;
        this.username = u;
        this.password = pwd;
        this.confirmpwd = cpwd;
        this.ieccode = iec;
        this.companytype = ctype;
        this.stuffingType = stype;

    }

}




// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/model/Signup-model.ts